import {FC} from "react";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {selectApprovePPHPopupVisible, setApprovePPHPopupVisible} from "../../../features/AppStateSlice";
import {ApprovePPHDialog} from "../approvepph/ApprovePPHDialog";

const ApprovePPHPopup: FC = () => {
    const dispatch = useAppDispatch();
    const isVisible = useAppSelector(selectApprovePPHPopupVisible);

    return (
        <ApprovePPHDialog zIndex={1100} show={isVisible}
                         onClose={() => dispatch(setApprovePPHPopupVisible(false))} />
    );
}

export default ApprovePPHPopup;
